import { render, staticRenderFns } from "./PlanConfirmado.vue?vue&type=template&id=4e5d872a&scoped=true"
import script from "./PlanConfirmado.vue?vue&type=script&lang=js"
export * from "./PlanConfirmado.vue?vue&type=script&lang=js"
import style0 from "./PlanConfirmado.vue?vue&type=style&index=0&id=4e5d872a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d872a",
  null
  
)

export default component.exports